module.exports = __webpack_public_path__ + "img/Microphone - White - Selected.7b3c8c71.png";